import React from 'react';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { translate } from 'components/Translation';
import { HeadingSBold } from 'components/Typography/Typography';
import CustomInput from 'components/CustomInput/CustomInput';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/nameLoyaltyTabStyle';
import CardButtons from 'views/PrepaidLoyalty/RegisteringNewLoyalty/components/CardButtons';

// @ts-ignore
const useStyles = makeStyles(styles);

interface INameLoyaltyTab {
	name: string;
	setName: React.Dispatch<React.SetStateAction<string>>;
	buttons: types.prepaidLoyalty.IButton[];
}

const NameLoyaltyTab = ({ name, setName, buttons }: INameLoyaltyTab) => {
	const classes = useStyles();

	return (
		<Card className={classes.card}>
			<CardBody>
				<HeadingSBold disableMargin>{translate('prepaid.loyalty.register.loyalty.name')}</HeadingSBold>
				<div className={classes.inputWrapper}>
					<CustomInput
						labelText={translate('prepaid.loyalty.type.loyalty.name')}
						inputProps={{
							required: true,
							value: name,
							type: 'text',
							onChange: (event: React.FormEvent<HTMLInputElement>) =>
								setName((event.target as HTMLInputElement).value),
						}}
						formControlProps={{
							fullWidth: true,
						}}
					/>
				</div>
				<CardButtons buttons={buttons} />
			</CardBody>
		</Card>
	);
};

export default NameLoyaltyTab;
